/**
 * ./src/utils/cookie.ts
 *
 * Functions to handle cookies
 *
 * @copyright DesignShop, 2024
 * @since 06/03/2024
 */

/**
 * getCookie, function to get a specific cookie.
 */
export function getCookie(cookieName: string) {
  if (typeof document !== 'undefined') {
    const cookie = document.cookie.match(`(^|;)\\s*${cookieName}\\s*=\\s*([^;]+)`);
    return cookie ? cookie.pop() : null;
  }
  return null; // Returns null on the server side
}

/**
 * setCookie, function to set a specific cookie.
 */
export function setCookie(cookieName: string, value: string, secondsTillExpire: number = 31536000) {
  if (typeof document !== 'undefined') {
    document.cookie = `${cookieName}=${value};max-age=${Math.floor(secondsTillExpire)};path=/`;
  }
}

/**
 * removeCookie, function to remove a specific cookie.
 */
export function removeCookie(cookieName: string) {
  if (typeof document !== 'undefined') {
    document.cookie = `${cookieName}=; Max-Age=0; path=/`;
  }
}
